import React from 'react';
import ProgramLandingTemplate from '../../components/ProgramLandingTemplate';
import { PROGRAM_DATA } from '../../config/programData';

const OA: React.FC<{ user?: any; onLogout: () => void; onLogin: () => void }> = ({ 
  user, 
  onLogout, 
  onLogin 
}) => {
  return <ProgramLandingTemplate program={PROGRAM_DATA.oa} user={user} onLogout={onLogout} onLogin={onLogin} />;
};

export default OA;
